import React from "react";
import styled from "styled-components/native"
import { themeTools, useBreakpointValue, useColorMode, } from "native-base"

import { VStack } from "~/native-ui/native-base";


export const Col = React.memo(({ xs, md, lg, sm, ...props}) => {
    const { colorMode } = useColorMode();
    const flexGrow = useBreakpointValue({
        base: xs ?? sm ?? md ?? lg ?? 1,
        md,
        lg,
        sm,
    });

    const colProps = {
            ...props,
            shadow: props.shadow || undefined,
            flexGrow: flexGrow,
            flexBasis: (100 / 12) + "%",
            space: props.space ?? 4,
            flexShrink: props.flex ?? 0,
            maxWidth: flexGrow * (100 / 12) + "%",
            borderRadius: props.borderRadius ?? 8,
            borderColor: props.borderColor ?? "muted.200",
            padding: props.padding ?? (props.shadow ? 4 : undefined),
            // paddingRight: flexGrow >= 12 ? props.padding : props.paddingRight ?? props.padding ?? 4,
            backgroundColor: props.backgroundColor ?? (!props.shadow ? undefined : themeTools.mode("light.50", "dark.50")({ colorMode }))
    }

    return <StyledCol { ...colProps } />
})

const StyledCol = styled(VStack)`
    ${
        (props) => props.shadow !== 1 
            ?   ""
            :   `
                border-width: 2px;
                border-style: solid;
                box-shadow: none;
            `
        
    }


    ${
        (props) => !(props.shadow)
            ?   ""
            :   `
                align-self: stretch;
            `
        
    }
`;